"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TypesenseError_1 = tslib_1.__importDefault(require("./TypesenseError"));
var RequestMalformed = /** @class */ (function (_super) {
    tslib_1.__extends(RequestMalformed, _super);
    function RequestMalformed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RequestMalformed;
}(TypesenseError_1.default));
exports.default = RequestMalformed;
//# sourceMappingURL=RequestMalformed.js.map